<template>
  <v-container>
    <v-form ref="form" v-model="valid" @submit.prevent="proximaPagina">
      <v-list class="pa-0" two-line>
        <v-toolbar height="56" color="primary">
          <v-toolbar-title class="subheading white--text">
            Risco
          </v-toolbar-title>
        </v-toolbar>
        <v-card class="pa-5">
          <v-flex mb-4 class="textblack"
            >Possuí Gerenciamento de Risco?
            <small
              class="error--text"
              v-if="mostrarError(idRiscoGerenciamento)"
            >
              Preenchimento obrigatório. Selecione uma opção.</small
            >
          </v-flex>

          <v-radio-group
            :rules="regras.notNull"
            :hide-details="true"
            required
            v-model="idRiscoGerenciamento"
            :disabled="camposDisabled"
          >
            <v-flex py-3 v-for="item in riscoGerenciamentoList" :key="item.id"
              ><v-radio :value="item.id"
                ><template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template>
              </v-radio></v-flex
            >
          </v-radio-group>
        </v-card>
        <v-card class="pa-5">
          <v-flex class="textblack">
            Qual a forma de Gerencimento de Risco?
            <small
              class="error--text"
              v-if="
                possuiGerenciamento &&
                mostrarError(idRiscoFormaGerenciamentoList)
              "

              >Preenchimento obrigatório. Selecione ao menos uma opção.</small
            >
            
          </v-flex>
          <small class="textblack">
            É possível selecionar mais de uma opção.</small
          >
          <v-layout row wrap>
            <v-flex
              sm6
              v-for="item in riscoFormaGerenciamentoList"
              :key="item.id"
              ><v-checkbox
                multiple
                v-model="idRiscoFormaGerenciamentoList"
                :label="item.titulo"
                :value="item.id"
                :rules="possuiGerenciamento ? regras.notNull : []"
                :hide-details="true"
                :disabled="!possuiGerenciamento || camposDisabled"
                ><template v-slot:label>
                  <div :class="possuiGerenciamento ? 'textblack' : 'disable'">
                    {{ item.titulo }}
                  </div>
                </template>
              </v-checkbox>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card class="pa-5">
          <v-flex mb-4 class="textblack">
            Condutores receberam curso de Direção Defensiva?
            <small
              class="error--text"
              v-if="mostrarError(idRiscoDirecaoDefensiva)"
            >
              Preenchimento obrigatório. Selecione uma opção.</small
            >
          </v-flex>
          <v-radio-group
            :rules="regras.notNull"
            :hide-details="true"
            required
            v-model="idRiscoDirecaoDefensiva"
            :disabled="camposDisabled"
          >
            <v-flex py-3 v-for="item in riscoOpcaoVeiculosList" :key="item.id"
              ><v-radio :value="item.id"
                ><template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template>
              </v-radio></v-flex
            >
          </v-radio-group>
        </v-card>
        <v-card class="pa-5">
          <v-flex class="textblack">
            Veículos com Limitador de Velocidade?
            <small
              class="error--text"
              v-if="mostrarError(idRiscoLimitadorVelocidade)"
            >
              Preenchimento obrigatório. Selecione uma opção.</small
            >
          </v-flex>
          <v-radio-group
            :rules="regras.notNull"
            :hide-details="true"
            required
            v-model="idRiscoLimitadorVelocidade"
            :disabled="camposDisabled"
          >
            <v-flex py-3 v-for="item in riscoOpcaoVeiculosList" :key="item.id"
              ><v-radio :value="item.id"
                ><template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template>
              </v-radio></v-flex
            >
          </v-radio-group>
        </v-card>
        <v-card class="pa-5">
          <v-flex class="textblack">
            Motorista participa com franquia, em caso de Sinistro?
            <small class="error--text" v-if="mostrarError(riscoSinistro)">
              Preenchimento obrigatório. Selecione uma opção.</small
            >
          </v-flex>
          <v-radio-group
            :rules="regras.notNull"
            :hide-details="true"
            required
            v-model="riscoSinistro"
            :disabled="camposDisabled"
          >
            <v-flex py-3 v-for="item in simOuNao" :key="item.titulo"
              ><v-radio :value="item.value"
                ><template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template>
              </v-radio></v-flex
            >
          </v-radio-group>
        </v-card>
        <v-card class="pa-5">
          <v-flex mb-4 class="textblack">
            Veículos possuem pintura especial de indentificação ou logotipo da
            empresa?
            <small
              class="error--text"
              v-if="mostrarError(idRiscoIdentificacaoVisual)"
            >
              Preenchimento obrigatório. Selecione uma opção.</small
            ></v-flex
          >
          <v-radio-group
            :rules="regras.notNull"
            :hide-details="true"
            required
            v-model="idRiscoIdentificacaoVisual"
            :disabled="camposDisabled"
          >
            <v-flex py-3 v-for="item in riscoOpcaoVeiculosList" :key="item.id"
              ><v-radio :value="item.id"
                ><template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template>
              </v-radio></v-flex
            >
          </v-radio-group>
        </v-card>
        <v-card class="pa-5">
          <v-flex mb-4 class="textblack">
            Veículos disponibilizam telefone para reclamações ("Como estou
            dirigindo?")
            <small class="error--text" v-if="mostrarError(idRiscoReclamacoes)">
              Preenchimento obrigatório. Selecione uma opção.</small
            ></v-flex
          >
          <v-radio-group
            :rules="regras.notNull"
            :hide-details="true"
            required
            v-model="idRiscoReclamacoes"
            :disabled="camposDisabled"
          >
            <v-flex py-3 v-for="item in riscoOpcaoVeiculosList" :key="item.id"
              ><v-radio :value="item.id">
                <template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template></v-radio
              ></v-flex
            >
          </v-radio-group>
        </v-card>
        <v-card class="pa-5">
          <v-flex mb-4 class="textblack">
            Empresa tem premiação para Bons Motoristas?
            <small class="error--text" v-if="mostrarError(riscoBonsMotoristas)">
              Preenchimento obrigatório. Selecione uma opção.</small
            ></v-flex
          >
          <v-radio-group
            :rules="regras.notNull"
            :hide-details="true"
            required
            v-model="riscoBonsMotoristas"
            :disabled="camposDisabled"
          >
            <v-flex py-3 v-for="item in simOuNao" :key="item.titulo"
              ><v-radio :value="item.value">
                <template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template></v-radio
              ></v-flex
            >
          </v-radio-group>
        </v-card>
        <v-card class="pa-5">
          <v-flex mb-4 class="textblack">
            Empresa tem punição para Maus Motoristas?
            <small class="error--text" v-if="mostrarError(riscoMausMotoristas)">
              Preenchimento obrigatório. Selecione uma opção.</small
            ></v-flex
          >
          <v-radio-group
            :rules="regras.notNull"
            :hide-details="true"
            required
            v-model="riscoMausMotoristas"
            :disabled="camposDisabled"
          >
            <v-flex py-3 v-for="item in simOuNao" :key="item.titulo"
              ><v-radio :value="item.value">
                <template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template></v-radio
              ></v-flex
            >
          </v-radio-group>
        </v-card>
        <v-card class="pa-5">
          <v-flex mb-4 class="textblack">
            O veículo fica em poder do funcionário todo o tempo?
            <small
              class="error--text"
              v-if="mostrarError(riscoVeiculoFuncionario)"
            >
              Preenchimento obrigatório. Selecione uma opção.</small
            ></v-flex
          >
          <v-radio-group
            :rules="regras.notNull"
            :hide-details="true"
            required
            v-model="riscoVeiculoFuncionario"
            :disabled="camposDisabled"
          >
            <v-flex py-3 v-for="item in simOuNao" :key="item.titulo"
              ><v-radio :value="item.value">
                <template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template></v-radio
              ></v-flex
            >
          </v-radio-group>
        </v-card>
        <v-card class="pa-5">
          <v-flex class="textblack">
            Quando fora de uso, onde se faz a guarda dos veículos?
            <small
              class="error--text"
              v-if="mostrarError(idRiscoPermanenciaVeiculoForaList)"
              >Preenchimento obrigatório. Selecione ao menos uma opção.</small
            ></v-flex
          >
          <small class="textblack">
            É possível selecionar mais de uma opção.</small
          >
          <v-layout row wrap>
            <v-flex
              sm6
              v-for="item in riscoPermanenciaVeiculoForaList"
              :key="item.id"
              ><v-checkbox
                multiple
                v-model="idRiscoPermanenciaVeiculoForaList"
                :label="item.titulo"
                :value="item.id"
                required
                :rules="regras.notNull"
                :hide-details="true"
                :disabled="camposDisabled"
                ><template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template>
              </v-checkbox></v-flex
            >
          </v-layout>
        </v-card>
        <v-card class="pa-5">
          <v-flex mb-4 class="textblack">
            É contratado seguro para a carga transportada?
            <small class="error--text" v-if="mostrarError(riscoSeguroCarga)">
              Preenchimento obrigatório. Selecione uma opção.</small
            ></v-flex
          >
          <v-radio-group
            required
            :rules="regras.notNull"
            :hide-details="true"
            v-model="riscoSeguroCarga"
            :disabled="camposDisabled"
          >
            <v-flex py-3 v-for="item in simOuNao" :key="item.titulo"
              ><v-radio :value="item.value">
                <template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template></v-radio
              ></v-flex
            >
          </v-radio-group>
        </v-card>
        <v-card class="pa-5">
          <v-flex class="textblack">
            Qual é o segmento de transporte / operação?
            <small
              class="error--text"
              v-if="mostrarError(idRiscoSegmentoEmbarcadorList)"
              >Preenchimento obrigatório. Selecione ao menos uma opção.</small
            ></v-flex
          >
          <small class="textblack">
            É possível selecionar mais de uma opção.</small
          >
          <v-layout row wrap>
            <v-flex sm6 v-for="item in riscoSegmentoAtuacaoList" :key="item.id"
              ><v-checkbox
                multiple
                v-model="idRiscoSegmentoAtuacaoList"
                :label="item.titulo"
                :value="item.id"
                required
                :rules="regras.notNull"
                :hide-details="true"
                :disabled="camposDisabled"
                ><template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template>
              </v-checkbox></v-flex
            >
          </v-layout>
        </v-card>
        <v-card class="pa-5">
          <v-flex class="textblack">
            Qual é o segmento do embarcador?
            <small
              class="error--text"
              v-if="mostrarError(idRiscoSegmentoEmbarcadorList)"
              >Preenchimento obrigatório. Selecione ao menos uma opção.</small
            ></v-flex
          >
          <small class="textblack">
            É possível selecionar mais de uma opção.</small
          >
          <v-layout row wrap>
            <v-flex
              sm6
              v-for="item in riscoSegmentoEmbarcadorList"
              :key="item.id"
              ><v-checkbox
                multiple
                v-model="idRiscoSegmentoEmbarcadorList"
                :label="item.titulo"
                :value="item.id"
                required
                :rules="regras.notNull"
                :hide-details="true"
                :disabled="camposDisabled"
                ><template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template>
              </v-checkbox></v-flex
            >
          </v-layout>
        </v-card>
        <v-card class="pa-5">
          <v-flex class="textblack">
            Qual é a região geográfica de maior circulação?
            <small
              class="error--text"
              v-if="mostrarError(idRiscoRegiaoCirculacaoList)"
              >Preenchimento obrigatório. Selecione ao menos uma opção.</small
            >
          </v-flex>
          <small class="textblack">
            É possível selecionar mais de uma opção.</small
          >
          <v-layout row wrap>
            <v-flex sm6 v-for="item in riscoRegiaoCirculacaoList" :key="item.id"
              ><v-checkbox
                multiple
                v-model="idRiscoRegiaoCirculacaoList"
                :label="item.titulo"
                :value="item.id"
                required
                :rules="regras.notNull"
                :hide-details="true"
                :disabled="camposDisabled"
                ><template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template>
              </v-checkbox></v-flex
            >
          </v-layout>
        </v-card>
        <v-card class="pa-5">
          <v-flex class="textblack">
            Os veículos trafegam nos estados de São Paulo e Rio de Janeiro,
            ainda que eventualmente?

            <small
              class="error--text"
              v-if="mostrarError(riscoTrafegamEstados)"
            >
              Preenchimento obrigatório. Selecione uma opção.</small
            ></v-flex
          >
          <small class="textblack"
            >Esta resposta pode reduzir o prêmio do seguro e, no caso da
            ocorrência de um sinistro nos estados do RJ ou SP, não será paga
            indenização por ser entendido como risco não contratado.</small
          >
          <v-radio-group
            v-model="riscoTrafegamEstados"
            :rules="regras.notNull"
            :hide-details="true"
            :disabled="camposDisabled"
          >
            <v-flex py-3 v-for="item in simOuNao" :key="item.titulo"
              ><v-radio :value="item.value" required
                ><template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template>
              </v-radio></v-flex
            >
          </v-radio-group>
        </v-card>
        <v-card class="pa-5">
          <v-flex class="textblack">
            Transporta alguma dessas cargas, mesmo que eventualmente?
            <small
              class="error--text"
              v-if="mostrarError(idRiscoCargasEventuaisList)"
              >Preenchimento obrigatório. Selecione ao menos uma opção.</small
            >
            
          </v-flex>
          <small class="textblack"
            >É possível selecionar mais de uma opção.
          </small>
          <v-layout row wrap>
            <v-flex sm6 v-for="item in riscoCargasEventuaisList" :key="item.id"
              ><v-checkbox
                multiple
                v-model="idRiscoCargasEventuaisList"
                :label="item.titulo"
                :value="item.id"
                required
                :rules="regras.notNull"
                :hide-details="true"
                :disabled="camposDisabled"
                ><template v-slot:label>
                  <div class="textblack">{{ item.titulo }}</div>
                </template>
              </v-checkbox></v-flex
            >
          </v-layout>
        </v-card>
        <v-card class="pa-5">
          <v-flex mb-4 class="textblack"> Informações Complementares</v-flex>
          <v-layout>
            <v-flex xs12 sm8 pr-5>
              <v-textarea
                v-model="informacoesComplementares"
                class="textarea"
                outline
                :disabled="camposDisabled"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-card>
      </v-list>
      <v-layout pt-5 align-center>
        <v-spacer></v-spacer>
        <BotaoRecusarCotacao :idApolice="idApolice" :idPropostaStatus="idPropostaStatus" variant="footer" class="mr-3" />
        <v-btn color="primary" @click="voltar" outline class="mr-3"> Voltar </v-btn>
        <v-btn
          type="submit"
          class="button-custom"
          flat
          @click="formBotaoClicado = true"
        >
          Próximo
        </v-btn>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import axios from "axios";
import permissoes from "@/helpers/permissoes";
import usuarioHelper from "@/helpers/usuario-logado.js";
import wizardCotacao from "@/helpers/wizard-cotacao.js";
import { mapState } from "vuex";
import BotaoRecusarCotacao from "./BotaoRecusarCotacao.vue";

export default {
  name: "Risco",
  components: {
    BotaoRecusarCotacao
  },
  data() {
    return {
      formBotaoClicado: false,
      simOuNao: [
        {
          value: true,
          titulo: "Sim",
        },
        {
          value: false,
          titulo: "Não",
        },
      ],
      statusAtualApolice: null,
      riscoCargasEventuaisList: [],
      riscoFormaGerenciamentoList: [],
      riscoGerenciamentoList: [],
      riscoOpcaoVeiculosList: [],
      riscoPermanenciaVeiculoForaList: [],
      riscoRegiaoCirculacaoList: [],
      riscoSegmentoAtuacaoList: [],
      riscoSegmentoEmbarcadorList: [],
      idRiscoCargasEventuaisList: null,
      idRiscoFormaGerenciamentoList: null,
      idRiscoGerenciamento: null,
      idRiscoDirecaoDefensiva: null,
      idRiscoLimitadorVelocidade: null,
      idRiscoIdentificacaoVisual: null,
      idRiscoReclamacoes: null,
      idRiscoPermanenciaVeiculoForaList: null,
      idRiscoRegiaoCirculacaoList: null,
      idRiscoSegmentoAtuacaoList: null,
      idRiscoSegmentoEmbarcadorList: null,
      riscoSinistro: null,
      riscoBonsMotoristas: null,
      riscoMausMotoristas: null,
      riscoVeiculoFuncionario: null,
      riscoSeguroCarga: null,
      riscoTrafegamEstados: null,
      informacoesComplementares: null,
      idApolice: null,
      regras: {
        notNull: [
          (v) =>
            !!(v instanceof Array ? v.length : v !== null) ||
            "Você não pode deixar este campo em branco",
        ],
      },
      valid: true,
    };
  },
  watch: {
    idRiscoGerenciamento(valorNovo) {
      if (valorNovo !== 1 && valorNovo !== 2) {
        this.idRiscoFormaGerenciamentoList = null;
      }
    },
  },
  computed: {
    ...mapState("formCotacao", ["idPropostaStatus"]),
    possuiGerenciamento() {
      return this.idRiscoGerenciamento === 1 || this.idRiscoGerenciamento === 2;
    },
    camposDisabled() {
      if (this.idPropostaStatus > 1  && this.idPropostaStatus < 6) {
        return true
       }
       else if (this.idPropostaStatus == 7) {
        return true
       }

    },
  },
  mounted() {
    this.$store.commit("startLoading");
    this.idApolice = this.$route.query.id;
    this.statusAtualApolice = this.$route.query.idPropostaStatus ? this.$route.query.idPropostaStatus : null;
   
    Object.entries(this.$store.getters["formCotacao/risco"]).forEach(
      ([key, value]) => {
        if (
          (this[key] instanceof Array &&
            value instanceof Array &&
            !this[key].length) ||
          value !== null
        ) {
          this[key] = value;
        }
      }
    );
    this.$store.commit("endLoading");
    const destinoWizard = wizardCotacao.proximaRotaWizard(
      wizardCotacao.ETAPAS.RISCO,
      this.$store.getters["formCotacao/estadoWizard"]
    );
    if (destinoWizard) {
      return this.$router.push(
        wizardCotacao.rotaWizard(destinoWizard, this.idApolice)
      );
    }
    
    this.buscaOpcoes();
  },
  methods: {
    mostrarError(model) {
      return (
        this.formBotaoClicado &&
        !(model instanceof Array ? model.length : model !== null)
      );
    },

    buscaOpcoes() {
      [
        "riscoCargasEventuais",
        "riscoFormaGerenciamento",
        "riscoGerenciamento",
        "riscoOpcaoVeiculos",
        "riscoPermanenciaVeiculoFora",
        "riscoRegiaoCirculacao",
        "riscoSegmentoAtuacao",
        "riscoSegmentoEmbarcador",
      ].forEach((item) => {
        axios
          .get(`${process.env.URL_APOLICEMS}/v1/${item}`, {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          })
          .then((response) => {
            this[`${item}List`] =
              response.data instanceof Array ? response.data : [];
          })
          .catch((err) => {
            console.error(err);
          });
      });
    },
    proximaPagina: function () {
      if (this.$refs.form.validate()) {
        this.$store.commit("formCotacao/setRisco", {
          idRiscoCargasEventuaisList: this.idRiscoCargasEventuaisList,
          idRiscoFormaGerenciamentoList: this.possuiGerenciamento
            ? this.idRiscoFormaGerenciamentoList
            : [],
          idRiscoGerenciamento: this.idRiscoGerenciamento,
          idRiscoDirecaoDefensiva: this.idRiscoDirecaoDefensiva,
          idRiscoLimitadorVelocidade: this.idRiscoLimitadorVelocidade,
          idRiscoIdentificacaoVisual: this.idRiscoIdentificacaoVisual,
          idRiscoReclamacoes: this.idRiscoReclamacoes,
          idRiscoPermanenciaVeiculoForaList:
            this.idRiscoPermanenciaVeiculoForaList,
          idRiscoRegiaoCirculacaoList: this.idRiscoRegiaoCirculacaoList,
          idRiscoSegmentoAtuacaoList: this.idRiscoSegmentoAtuacaoList,
          idRiscoSegmentoEmbarcadorList: this.idRiscoSegmentoEmbarcadorList,
          riscoSinistro: this.riscoSinistro,
          riscoBonsMotoristas: this.riscoBonsMotoristas,
          riscoMausMotoristas: this.riscoMausMotoristas,
          riscoVeiculoFuncionario: this.riscoVeiculoFuncionario,
          riscoSeguroCarga: this.riscoSeguroCarga,
          riscoTrafegamEstados: this.riscoTrafegamEstados,
          informacoesComplementares: this.informacoesComplementares,
        });
        if (this.$route.query.apoliceCopiada == "true") {
          this.$router.push(`/GridPrincipal/GridVeiculos?id=${this.idApolice}&apoliceCopiada=${true}${this.statusAtualApolice ? `&idPropostaStatus=${this.statusAtualApolice}` : ''}`);
        } else if(this.$route.query.apoliceRenovacao) {
          this.$router.push(`/GridPrincipal/GridVeiculos?id=${this.idApolice}&apoliceRenovacao=${true}${this.statusAtualApolice ? `&idPropostaStatus=${this.statusAtualApolice}` : ''}`);
        } else {
          this.$router.push(
            `/GridPrincipal/GridVeiculos${this.idApolice ? `?id=${this.idApolice}` : ''}${this.statusAtualApolice ? `&idPropostaStatus=${this.statusAtualApolice}` : ''}`
          );
        }
      }
    },
    voltar: function () {
      if (this.$route.query.apoliceCopiada == "true") {
        this.$router.push(`/GridPrincipal/InfoGerais?id=${this.idApolice}&apoliceCopiada=${true}${this.statusAtualApolice ? `&idPropostaStatus=${this.statusAtualApolice}` : ''}`);
      } else if(this.$route.query.apoliceRenovacao) {
        this.$router.push(`/GridPrincipal/InfoGerais?id=${this.idApolice}&apoliceRenovacao=${true}${this.statusAtualApolice ? `&idPropostaStatus=${this.statusAtualApolice}` : ''}`);
      } else {
        this.$router.push(
          `/GridPrincipal/InfoGerais${this.idApolice ? `?id=${this.idApolice}` : ''}${this.statusAtualApolice ? `&idPropostaStatus=${this.statusAtualApolice}` : ''}`
        );
      }
    },
  },
};
</script>

<style scoped>
.button-custom {
  width: 100%;
  max-width: 121px;
  text-align: center;
  color: #fff !important;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;

  font-weight: bold;
}
.textblack {
  color: #757575;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/Risco.vue